import { useFeatureValue } from '@growthbook/growthbook-react'

// Fail-open by design: useFeatureValue() already resolves to `defaultValue`
// whenever GrowthBook hasn't loaded, failed to load, or the key is unknown.
export function useFeatureFlag(key, defaultValue) {
  return useFeatureValue(key, defaultValue)
}
